import { useTranslations } from '@vocab/react';
import { Bleed, Drawer } from 'braid-design-system';
import type { ReactNode } from 'react';

import { CareerFeedAIHeading } from '../../CareerFeedAIHeading';

import translations from './.vocab';

interface CareerFeedAIAssistantDrawerProps {
  children: ReactNode;
  shouldOpen?: boolean;
  onClose?: () => void;
}

export const CareerFeedAIAssistantDrawer = ({
  children,
  shouldOpen = false,
  onClose = () => {},
}: CareerFeedAIAssistantDrawerProps) => {
  const { t } = useTranslations(translations);

  return (
    <Drawer
      title=""
      width="small"
      onClose={onClose}
      open={shouldOpen}
      id="career-feed-desktop-drawer"
    >
      <Bleed top="large">
        <CareerFeedAIHeading headingText={t('Define your preferences')} />
      </Bleed>
      {children}
    </Drawer>
  );
};
